import { FC } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { setSEOSettings } from "../../../store/slices/main";
import Play from "../../../assets/icon/Play";
import { setYoutubeUrlState } from "../../../store/slices/news";

type IProps = {
  id: string;
  icon?: string;
  title: string;
  description: string;
  date?: string;
  link?: string;
  metaDescription?: string;
  youtubeUrl?: string;
};

const NewsCard: FC<IProps> = ({
  id,
  icon,
  title,
  description,
  date,
  link,
  metaDescription,
  youtubeUrl,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const createDate = moment(date).format("DD.MM.YYYY");

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string
  ) => {
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  const handeleClick = (link: string) => {
    dispatch(setYoutubeUrlState(link));
  };

  return (
    <>
      <div className="flex min-w-[20rem] justify-start items-center pr-5 pt-7 text-sm md:min-w-[46%] md:max-w-[46%] overflow-hidden text-ellipsis line-clamp-1">
        <div
          className={`max-w-[12rem] min-w-[12rem] max-h-[6.75rem] min-h-[6.75rem] flex justify-start items-center overflow-hidden rounded-md ${
            youtubeUrl && "relative"
          }`}
        >
          <img
            onClick={() =>
              navigateAndSetSEOSettings(
                `/news/${link}`,
                title,
                metaDescription ? metaDescription : description,
                icon ? icon : ""
              )
            }
            className={`w-full h-full object-cover cursor-pointer`}
            src={icon}
            alt={title}
          />
          <div
            onClick={() => {
              if (youtubeUrl) {
                handeleClick(youtubeUrl);
              }
            }}
            className={`${
              youtubeUrl &&
              "absolute left-[4.8rem] top-50% z-20 cursor-pointer opacity-90 rounded-full hover:bg-orange_hover "
              // "absolute left-[3.5rem] top-50% z-20 cursor-pointer opacity-90 rounded-full hover:border hover:border-orange_hover hover:rounded-full hover:opacity-100 hover:transition-opacity"
            }`}
          >
            <Play />
          </div>
          <div
            className={`${
              youtubeUrl &&
              "absolute top-0 left-0 w-full h-full z-10 bg-black opacity-40"
            }`}
          ></div>
        </div>

        <div className="flex flex-col pl-3 justify-start h-full">
          <div
            onClick={() =>
              navigateAndSetSEOSettings(
                `/news/${link}`,
                title,
                metaDescription ? metaDescription : description,
                icon ? icon : ""
              )
            }
            className="w-full max-h-[4rem] text-sm"
          >
            <h3
              className="block w-full mb-1 text-base leading-5 font-semibold text-black text-ellipsis overflow-hidden line-clamp-3 md:hover:underline cursor-pointer"
              style={{
                overflow: "hidden",
                display: "-webkit-box",
              }}
            >
              {title}
            </h3>
          </div>
          <div>
            <span className="opacity-80">{createDate}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsCard;
